import { i18n } from './translator.js';
import globalStylesUrl from 'url:../styles/global.css';
import portalStylesUrl from 'url:../styles/portal.css';
import headerLogoUrl from 'url:../images/logo.svg';
import phUser from 'url:../images/svg/ph-user.svg';
class UserHeader extends HTMLElement {
  constructor() {
    super();
    // Crucial: Must be set to 'open' so our scanner can access it
    this.attachShadow({ mode: 'open' });
    //this.shadowRoot.adoptedStyleSheets = [globalStyles];
    // 1. Initialize private backing fields with default fallback URLs

    this._desktopUrl = 'https://p1mm.org';
    this._loading = true;
    this._userName = '';
    this._avatarUrl = '';
    this._isAdmin = false;
  }

  // 1. Tell the component which attributes to watch
  static get observedAttributes() {
    return ['loading', 'user-name', 'avatar-url', 'is-admin'];
  }

  // 2. Automatically re-run the logic if an attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    if (name === 'is-admin') {
      this._isAdmin = newValue === 'true';
      this.toggleCaseTabs(this._isAdmin);
      return;
    }
    // Track internally
    if (name === 'loading')
      this._loading = newValue !== 'false' && newValue !== null;
    if (name === 'user-name') this._userName = newValue;
    if (name === 'avatar-url') this._avatarUrl = newValue;

    // Direct DOM sync loop: Only manipulate elements if the shell is built
    if (this.shadowRoot.getElementById('navbar-header')) {
      this.syncDOMState();
    }
  }

  toggleCaseTabs(isAdmin) {
    const caseTabLinks = document.querySelectorAll(
      '[data-target="panel-cases"]',
    );
    caseTabLinks.forEach((link) => {
      link.style.display = isAdmin ? 'flex' : 'none';
    });
    document
      .getElementById('sidebar-drawer')
      .classList.remove('loading-skeleton');
    document
      .querySelector('.sub-nav-tabs')
      .classList.remove('loading-skeleton');
  }

  // TODO: START here: copy header from new index.html
  render() {
    this.shadowRoot.innerHTML = `
    <link rel="stylesheet" href="${globalStylesUrl}">
    <link rel="stylesheet" href="${portalStylesUrl}">
    <style>
      /* --- INFINITE SHIMMER ANIMATION ENGINE --- */
      @keyframes shimmerWave {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
      }

      /* 1. Base styles for fields in their normal (loaded) state */
      .top-navbar .profile-avatar,
      .top-navbar .profile-name,
      .top-navbar .drop-link {
          /* Smoothly animate background modifications and color transitions */
          transition: background-color 0.4s ease, color 0.4s ease, border-color 0.4s ease;
          background-color: transparent;
          color: inherit;
      }

      /* 2. Overriding styles applied dynamically while actively loading */
      .top-navbar.is-loading .profile-avatar,
      .top-navbar.is-loading .profile-name,
      .top-navbar.is-loading .drop-link {
          color: transparent !important;
          border-color: transparent !important;
          pointer-events: none;
          border-radius: 4px;
          
          background: linear-gradient(
              90deg, 
              #f1f5f9 25%, 
              #cbd5e1 50%, 
              #f1f5f9 75%
          );
          background-size: 200% 100%;
          animation: shimmerWave 1.6s infinite linear;
      }

      /* Ensure the avatar stays perfectly circular in both states */
      .top-navbar .profile-avatar {
          border-radius: 50%;
      }
      .top-navbar.is-loading .profile-avatar {
          border-radius: 50% !important;
      }

      /* Turn off menu dropdown hover effects if the bar is actively loading */
      .top-navbar.is-loading .user-profile-menu:hover .user-profile-dropdown {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
      }   
    </style>
    <!-- Header Navigation -->
    <header class="top-navbar ${this._loading ? 'is-loading' : ''}">
      <div class="nav-left">
        <button
          id="drawer-toggle"
          class="nav-toggle"
          aria-label="Toggle navigation"
          data-i18n-attr='{"aria-label":"toggle_nav"}'
          >
          <span class="hamburger"></span>
        </button>
        <div class="logo">
          <a href="index.html">
            <img
              src="${headerLogoUrl}"
              alt="P1MM Logo"
              width="48px"
              data-i18n-attr='{"alt":"p1mm_logo"}'
            />
            <span data-i18n="head_p1mm">Por Un Mundo Mejor</span>
          </a>
        </div>
      </div>

      <div class="nav-right">
           <button
          data-i18n="donate"
          class="btn-donate-nav"
          data-i18n-attr='{"zeffy-form-link":"zeffy_donation_url"}'
          zeffy-form-link=""
        >
          Donate
        </button>
        <select class="lang-select" id="selLang">
          <option value="en" selected title="en">English</option>
          <option value="es" title="es">Español</option>
        </select>

        <!-- User Login / Profile Picture Option -->
        <div class="h-flex user-profile-menu pos-rel" id="mnUserProfile">
          <img
             src="${this._loading ? phUser : this._avatarUrl || phUser}"
            alt="User Profile"
            class="profile-avatar"
            id="header-avatar-img"
            data-i18n-attr='{"alt":"nav_user_profile"}'
          />
          <span class="profile-name"
            ><span id="pfName">${this._loading ? 'Loading...' : this._userName || 'User'}</span> <span>▼</span></span
          >
          <div class="user-profile-dropdown">
            <button class="drop-link" data-target="panel-profile" data-i18n="profile">Profile</button>
            <button id="btnLogout" data-i18n="logout">Logout</button>
          </div>
        </div>
      </div>
    </header>
    `;
  }

  connectedCallback() {
    this.buildBaseStructure();

    // 2. Initialize language selection switcher and custom dashboard events
    const switcher = this.shadowRoot.getElementById('selLang');
    if (switcher && typeof i18n !== 'undefined') {
      i18n.initFromElement(switcher);
    }
    this.initDashboard();

    // window.addEventListener('name-updated', (e) => {
    //   const headerName = this.shadowRoot.getElementById('pfName');
    //   if (headerName && e.detail.newName) {
    //     headerName.textContent = e.detail.newName;
    //   }
    // });
  }
  // Generates the layout layout, styles, and links ONE time
  buildBaseStructure() {
    this.shadowRoot.innerHTML = `
      <link rel="stylesheet" href="${globalStylesUrl}">
      <link rel="stylesheet" href="${portalStylesUrl}">
      <style>
        /* --- INFINITE SHIMMER ANIMATION ENGINE --- */
        @keyframes shimmerWave {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .top-navbar .profile-avatar, .top-navbar .profile-name, .top-navbar .drop-link {
          transition: background-color 0.4s ease, color 0.4s ease, border-color 0.4s ease;
          background-color: transparent;
          color: inherit;
        }
        .top-navbar.is-loading .profile-avatar, .top-navbar.is-loading .profile-name, .top-navbar.is-loading .drop-link {
          color: transparent !important;
          border-color: transparent !important;
          pointer-events: none;
          border-radius: 4px;
          background: linear-gradient(90deg, #f1f5f9 25%, #cbd5e1 50%, #f1f5f9 75%);
          background-size: 200% 100%;
          animation: shimmerWave 1.6s infinite linear;
        }
        .top-navbar .profile-avatar { border-radius: 50%; }
        .top-navbar.is-loading .profile-avatar { border-radius: 50% !important; }
        .top-navbar.is-loading .user-profile-menu:hover .user-profile-dropdown {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }
      </style>

      <header id="navbar-header" class="top-navbar is-loading">
        <div class="nav-left">
          <button id="drawer-toggle" class="nav-toggle" aria-label="Toggle navigation" data-i18n-attr='{"aria-label":"toggle_nav"}'>
            <span class="hamburger"></span>
          </button>
          <div class="logo">
            <a href="index.html">
              <img src="${headerLogoUrl}" alt="P1MM Logo" width="48px" data-i18n-attr='{"alt":"p1mm_logo"}' />
              <span data-i18n="head_p1mm">Por Un Mundo Mejor</span>
            </a>
          </div>
        </div>
        <div class="nav-right">
          <button data-i18n="donate" class="btn-donate-nav" data-i18n-attr='{"zeffy-form-link":"zeffy_donation_url"}' zeffy-form-link="">
            Donate
          </button>
          <select class="lang-select" id="selLang">
            <option value="en" selected title="en">English</option>
            <option value="es" title="es">Español</option>
          </select>
          <div class="h-flex user-profile-menu pos-rel" id="mnUserProfile">
            <img src="${phUser}" alt="User Profile" class="profile-avatar" id="header-avatar-img" data-i18n-attr='{"alt":"nav_user_profile"}' />
            <span class="profile-name">
              <span id="pfName">Loading...</span>
              <span>▼</span>
            </span>
            <div class="user-profile-dropdown">
              <button class="drop-link" data-target="panel-profile" data-i18n="profile">Profile</button>
              <button id="btnLogout" data-i18n="logout">Logout</button>
            </div>
          </div>
        </div>
      </header>
    `;

    // Set immediate initial layout attributes before network responses return
    this.syncDOMState();
  }

  // Pinpoint targeted elements for state sync—No layout breakdown
  syncDOMState() {
    const header = this.shadowRoot.getElementById('navbar-header');
    const avatarImg = this.shadowRoot.getElementById('header-avatar-img');
    const nameSpan = this.shadowRoot.getElementById('pfName');

    if (!header) return;

    // Toggle parent CSS layout class to mask/unmask loader shimmer
    header.classList.toggle('is-loading', this._loading);

    if (this._loading) {
      if (avatarImg) avatarImg.src = phUser;
      if (nameSpan) nameSpan.textContent = 'Loading...';
    } else {
      if (avatarImg) avatarImg.src = this._avatarUrl || phUser;
      if (nameSpan) nameSpan.textContent = this._userName || 'User';
    }
  }

  initDashboard() {
    // 1. Mobile Sidebar Navigation Slider Handler Toggle
    const drawerToggle = this.shadowRoot.getElementById('drawer-toggle');
    const sidebarDrawer = document.getElementById('sidebar-drawer');

    drawerToggle.addEventListener('click', (e) => {
      sidebarDrawer.classList.toggle('open');
      e.stopPropagation();
    });

    // Close sidebar layout if clicking outside card frames on mobile screen sizes
    document.addEventListener('click', (e) => {
      if (
        window.innerWidth <= 1000 &&
        !sidebarDrawer.contains(e.target) &&
        sidebarDrawer.classList.contains('open')
      ) {
        sidebarDrawer.classList.remove('open');
      }
    });

    const mainTabLinks = document.querySelectorAll('.tab-link');
    const shadowDropLinks = this.shadowRoot.querySelectorAll('.drop-link');
    const sidebarLinks = document.querySelectorAll('.sidebar-link');
    // Combine both sets of buttons into a single array loop
    const allTabLinks = [...mainTabLinks, ...shadowDropLinks, ...sidebarLinks];
    const tabPanels = document.querySelectorAll('.tab-panel');

    allTabLinks.forEach((link) => {
      link.addEventListener('click', () => {
        // Clear active classes from ALL tracked navigation links
        allTabLinks.forEach((item) => item.classList.remove('active'));
        tabPanels.forEach((panel) => panel.classList.remove('active'));

        // Find the specific panel targeted by this click
        const targetId = link.getAttribute('data-target');
        console.log('Target ID for tab click:', targetId);
        const targetPanel = document.getElementById(targetId);

        if (targetPanel) {
          targetPanel.classList.add('active');

          // Match state: If a corresponding sidebar/sub-nav tab button exists for this view, highlight it too!
          allTabLinks.forEach((item) => {
            if (item.getAttribute('data-target') === targetId) {
              item.classList.add('active');
            }
          });

          this.dispatchEvent(
            new CustomEvent('tab-changed', {
              detail: { activeTabId: targetId },
              bubbles: true, // Allows the event to bubble up the DOM
              composed: true, // Allows the event to cross the Shadow DOM boundary if used
            }),
          );
        }
      });
    });
    const btnLogout = this.shadowRoot.getElementById('btnLogout');
    if (btnLogout) {
      btnLogout.addEventListener('click', () => {
        this.dispatchEvent(
          new CustomEvent('logout', {
            bubbles: true,
            composed: true,
          }),
        );
      });
    }
    const headerAvatar = this.shadowRoot.getElementById('header-avatar-img');

    if (headerAvatar) {
      // If the image is already cached/loaded by the browser, make sure it's visible
      if (headerAvatar.complete) {
        headerAvatar.style.opacity = '1';
      } else {
        // Start hidden, then fade in once the bytes finish downloading
        headerAvatar.style.opacity = '0';
        headerAvatar.style.transition = 'opacity 0.4s ease';

        headerAvatar.addEventListener('load', () => {
          headerAvatar.style.opacity = '1';
        });
      }
    }
  }
  initMobileNav() {
    // const burgerBtn = this.shadowRoot.getElementById('burgerBtn');
    // const mobileNav = this.shadowRoot.getElementById('mobileNav');

    // burgerBtn.addEventListener('click', () => {
    //   burgerBtn.classList.toggle('open');
    //   mobileNav.classList.toggle('open');
    // });
    const navToggle = this.shadowRoot.querySelector('.nav-toggle');
    const navLinks = this.shadowRoot.querySelector('.nav-links');

    if (navToggle && navLinks) {
      navToggle.addEventListener('click', () => {
        // Toggle the animation utility classes on both elements
        navToggle.classList.toggle('is-active');
        navLinks.classList.toggle('is-active');
      });

      // Close the menu automatically if a user clicks an internal link
      navLinks.querySelectorAll('a:not(.dropdown-trigger)').forEach((link) => {
        link.addEventListener('click', () => {
          navToggle.classList.remove('is-active');
          navLinks.classList.remove('is-active');
        });
      });
    }
    // 2. NEW: Submenu Toggle for Mobile Touchscreens
    const dropdownTrigger = this.shadowRoot.querySelector('.dropdown-trigger');
    const navDropdown = this.shadowRoot.querySelector('.nav-dropdown');
    if (dropdownTrigger && navDropdown) {
      dropdownTrigger.addEventListener('click', (e) => {
        // Only run this logic on mobile screens
        if (window.innerWidth <= 1000) {
          e.preventDefault(); // Stop the browser from instantly following the '#' link
          navDropdown.classList.toggle('is-open'); // Toggles open/closed states cleanly
        }
      });
    }
  }
}

// Register the custom elements
customElements.define('user-header', UserHeader);
